import React, { useState, useEffect, useContext } from "react";
import Button from "@mui/joy/Button";
import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import AuthContext from "../../contexts/authContext";
import { Box, Divider } from "@mui/joy";
import { FormControl, MenuItem, Select } from "@mui/material";
import axiosInstance from "../../api/axios";
import toast from "react-hot-toast";
import EditIcon from "@mui/icons-material/Edit";
import AddDesign from "./adddesign";
import DeleteIcon from "@mui/icons-material/Delete";
export default function ViewAsset({
  openViewAsset,
  setOpenViewAsset,
  setAssetId,
  assetId,
}) {
  const [viewData, setViewData] = useState([]);
  const { userData, setRefresh } = useContext(AuthContext);
  const [designsData, setDesignData] = useState();
  const [openConfirmDesignComplete, setOpenConfirmDesignComplete] =
    useState(false);
  const [designIdComp, setDesignIdComp] = useState("");
  const role = localStorage.getItem("role");
  const [designStatus, setDesignStatus] = useState("completed");
  const [assetStatus, setAssetStatus] = useState("completed");
  const [openConfirmAssetStatus, setOpenConfirmAssetStatus] = useState(false);
  const [designId, setDesignId] = useState("");
  const [openDesign, setOpenDesign] = useState(false);
  const [activeTab, setActiveTab] = useState("designs");

  const handleCompleteDesignConfirm = async () => {
    try {
      const res = await axiosInstance.put(`/designs/update/${designIdComp}`, {
        status: designStatus,
      });
      if (res.status === 200) {
        toast.success("Design completed successfully");
        setOpenConfirmDesignComplete(false);
        setDesignIdComp("");
        setRefresh(true);
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to complete design");
    }
  };

  const handleCloseAssetStatus = async () => {
    setOpenConfirmAssetStatus(false);
    setAssetStatus("");
  };
  const handleConfirmAssetStatus = async () => {
    try {
      const res = await axiosInstance.put(`/asset/update/${assetId}`, {
        status: assetStatus,
      });
      if (res.status === 200) {
        toast.success("Asset status updated successfully");
        setOpenConfirmAssetStatus(false);
        setAssetStatus("");
        handleCloseViewAsset();
        setRefresh(true);
      }
    } catch (error) {
      toast.error("Failed to update asset status");
    }
  };

  useEffect(() => {
    if (assetId) {
      const viewAsset = userData?.assets?.find((item) => item._id === assetId);
      setDesignData(viewAsset?.designs);
      setViewData(viewAsset);
    }
  }, [assetId, userData]);

  const handleCloseViewAsset = () => {
    setOpenViewAsset(false);
    setAssetId("");
    setViewData([]);
    setActiveTab("designs");
  };

  const handleCompleteDesign = (id) => {
    setDesignIdComp(id);
    setOpenConfirmDesignComplete(true);
  };
  const handleEditDesign = (id) => {
    setDesignId(id);
    setOpenDesign(true);
  };

  const handleDeleteDesign = async (id) => {
    try {
      const res = await axiosInstance.post(`/designs/delete/${id}`);
      if (res.status === 200) {
        toast.success("Design asset deleted successfully!");
        setRefresh(true);
      }
    } catch (err) {
      toast.error("An error occurred while deleting the design asset.");
    }
  };
  const handleCloseConfirmDesignComplete = () => {
    setOpenConfirmDesignComplete(false);
    setDesignIdComp("");
  };

  return (
    <React.Fragment>
      <Modal
        aria-labelledby="modal-title"
        aria-describedby="modal-desc"
        open={openViewAsset}
        onClose={handleCloseViewAsset}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Sheet
          variant="outlined"
          sx={{
            maxWidth: 600,
            width: "100%",
            bgcolor: "#FEDDDD",
            p: 3,
            borderRadius: "md",
            boxShadow: "lg",
            m: 2,
            overflow: "auto",
            maxHeight: "80vh",
          }}
        >
          <ModalClose
            variant="plain"
            sx={{
              m: 1,
              "& svg": { color: "#800001" },
              "&:hover": {
                backgroundColor: "#800001",
                "& svg": { color: "#fff" },
              },
            }}
          />

          <Box>
            <Typography
              component="h2"
              id="modal-title"
              level="h4"
              textColor="inherit"
              sx={{ fontWeight: "bold", mb: 1 }}
            >
              {viewData?.companyName}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1,
            }}
          >
            <Typography
              component="p"
              id="modal-desc"
              textColor="inherit"
              sx={{ color: "#555" }}
            >
              {viewData?.mobile}
            </Typography>

            {viewData?.status === "active" ? (
              <Button
                variant="solid"
                size="sm"
                onClick={() => setOpenConfirmAssetStatus(true)}
                sx={{
                  backgroundColor: "green",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#800001",
                  },
                  textTransform: "capitalize",
                }}
              >
                {viewData?.status}
              </Button>
            ) : (
              <Typography
                sx={{
                  color: viewData?.status === "cancelled" ? "red" : "#800001",
                  fontWeight: "bold",
                  fontSize: "16px",
                  textTransform: "capitalize",
                  mr: 2,
                }}
              >
                {viewData?.status}
              </Typography>
            )}
          </Box>
          <Box
            sx={{
              display: "flex",
              mb: 2,
              mt: 2,
              backgroundColor: "#fff",
              borderRadius: 10,
            }}
          >
            <Button
              onClick={() => setActiveTab("designs")}
              sx={{
                flex: 1,
                backgroundColor: activeTab === "designs" ? "#800001" : "#fff",
                color: activeTab === "designs" ? "#fff" : "#800001",
                borderRadius: 10,
                "&:hover": {
                  backgroundColor:
                    activeTab === "designs" ? "#800001" : "#ffe8e8",
                },
              }}
            >
              Designs
            </Button>

            <Button
              onClick={() => setActiveTab("updates")}
              sx={{
                flex: 1,
                backgroundColor: activeTab === "updates" ? "#800001" : "#fff",
                color: activeTab === "updates" ? "#fff" : "#800001",
                borderRadius: 10,
                "&:hover": {
                  backgroundColor:
                    activeTab === "updates" ? "#800001" : "#ffe8e8",
                },
              }}
            >
              Updates
            </Button>
          </Box>
          {activeTab === "designs" && (
            <Box sx={{ minHeight: "70vh", maxHeight: "70vh", borderRadius: 2 }}>
              <Typography sx={{ fontWeight: "bold", mb: 1, color: "#800001" }}>
                Designs
              </Typography>

              {designsData
                ?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                .map((item) => (
                  <Box
                    key={item._id}
                    sx={{
                      mb: 3,
                      p: 2,
                      backgroundColor: "#fff3f3",
                      borderRadius: 2,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 1,
                      }}
                    >
                      <Box>
                        <Typography
                          sx={{
                            textTransform: "uppercase",
                            fontWeight: "bold",
                            color: "#800001",
                            fontSize: "16px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item?.designName || ""} <br /> {item?.location || ""}
                        </Typography>
                        <Typography
                          sx={{
                            textTransform: "capitalize",
                            color: "#800001",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item?.agent?.name || "-"}
                        </Typography>
                        <Box
                          sx={{ display: "flex", gap: 1, alignItems: "center" }}
                        >
                          <Typography
                            sx={{
                              textTransform: "capitalize",
                              color:
                                item.status === "active"
                                  ? "green"
                                  : item.status === "completed"
                                  ? "#800001"
                                  : "red",
                              fontWeight: "medium",
                            }}
                          >
                            {item?.designId || "NA"} - {item?.assetType || ""}
                          </Typography>
                          {item?.status === "active" && (
                            <>
                              <Button
                                onClick={() => handleEditDesign(item._id)}
                                sx={{
                                  backgroundColor: "#800001",
                                  padding: 0,
                                  width: "30px",
                                  "&:hover": {
                                    backgroundColor: "#800001",
                                  },
                                  color: "#fff",
                                }}
                              >
                                <EditIcon sx={{ fontSize: "large" }} />
                              </Button>
                              <Button
                                onClick={() => handleDeleteDesign(item._id)}
                                sx={{
                                  backgroundColor: "#800001",
                                  padding: 0,
                                  width: "30px",
                                  "&:hover": {
                                    backgroundColor: "#800001",
                                  },
                                  color: "#fff",
                                }}
                              >
                                <DeleteIcon sx={{ fontSize: "large" }} />
                              </Button>
                            </>
                          )}
                        </Box>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          gap: 2,
                          alignItems: "center",
                          flexWrap: "wrap",
                          justifyContent: "center",
                        }}
                      >
                        {role !== "agent" && item?.status === "active" ? (
                          <Button
                            size="sm"
                            sx={{
                              backgroundColor: "#800001",
                              color: "#fff",
                              "&:hover": {
                                backgroundColor: "#800001",
                                color: "#fff",
                              },
                              textTransform: "capitalize",
                            }}
                            onClick={() => handleCompleteDesign(item._id)}
                          >
                            {item?.status}
                          </Button>
                        ) : (
                          <Typography
                            sx={{
                              color:
                                viewData?.status === "cancelled"
                                  ? "red"
                                  : "#800001",
                              fontWeight: "bold",
                              fontSize: "16px",
                              textTransform: "capitalize",
                              mr: 2,
                            }}
                          >
                            {item?.status}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        gap: 2,
                        mb: 1,
                        justifyContent: "space-between",
                      }}
                    >
                      <Box>
                        <Typography sx={{ fontWeight: "bold" }}>
                          Due Date
                        </Typography>
                        <Typography>
                          {item?.nextReminderDate
                            ? new Date(
                                item.nextReminderDate
                              ).toLocaleDateString()
                            : ""}
                        </Typography>
                      </Box>
                      <Box sx={{ display: "flex", gap: 2 }}>
                        <Box>
                          <Typography sx={{ fontWeight: "bold" }}>
                            Date
                          </Typography>
                          <Typography>
                            {item?.startDate
                              ? new Date(item.startDate).toLocaleDateString()
                              : ""}{" "}
                            -
                            {item?.endDate
                              ? new Date(item.endDate).toLocaleDateString()
                              : ""}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                    <Divider sx={{ my: 1 }} />
                    <Box
                      sx={{
                        display: "flex",
                        gap: 2,
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography
                        sx={{
                          textAlign: "left",
                          fontWeight: "bold",
                          mb: 1,
                          color: "#800001",
                        }}
                      >
                        Updates ↓
                      </Typography>
                    </Box>

                    {item.images?.length > 0 ? (
                      item.images.map((image) => (
                        <Box
                          key={image._id}
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            py: 1,
                            flexDirection: "column",
                            borderBottom: "1px solid #eee",
                          }}
                        >
                          <Box
                            component={"img"}
                            src={
                              "https://sakthiapi.mapsapp.in/uploads/" +
                              image.image
                            }
                            alt={"Images"}
                            style={{ width: "100%", height: "auto" }}
                          />
                          <Typography sx={{ fontSize: "14px", mt: 1 }}>
                            {image.createdAt?.split("T")[0]}
                          </Typography>
                          <Divider sx={{ width: "100%", mb: 5, mt: 2 }} />
                        </Box>
                      ))
                    ) : (
                      <Typography
                        sx={{ fontSize: "14px", color: "gray", mt: 1 }}
                      >
                        No payments yet
                      </Typography>
                    )}
                  </Box>
                ))}
            </Box>
          )}
          {activeTab === "updates" && (
            <Box
              sx={{
                borderRadius: 2,
                mt: 1,
                minHeight: "70vh",
                maxHeight: "70vh",
              }}
            >
              <Typography sx={{ color: "#800001", fontWeight: "bold", mb: 1 }}>
                Updates
              </Typography>

              {designsData?.map((design) => (
                <Box
                  key={design._id}
                  sx={{
                    backgroundColor: "#fff3f3",
                    p: 2,
                    borderRadius: 2,
                    mb: 2,
                    border: "1px solid #eee",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      mb: 1,
                      fontSize: "16px",
                      color: "#800001",
                    }}
                  >
                    {design.designId} — {design.designName}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      textAlign: "justify",
                      borderBottom: "1px solid #800001",
                    }}
                  >
                    <span style={{ fontWeight: "bold" }}>Description:</span>{" "}
                    {design.description}
                  </Typography>
                  {/* lorem ipsum dolor sit amet  */}
                  {/* Updates Section */}
                  {design.updates && design.updates.length > 0 ? (
                    design.updates
                      .sort((a, b) => new Date(b.date) - new Date(a.date))
                      .map((u, idx) => (
                        <Box
                          key={idx}
                          sx={{
                            borderBottom: "1px solid #ddd",
                          }}
                        >
                          <Typography sx={{ fontSize: "14px", py: 1 }}>
                            {u.text}
                          </Typography>

                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography
                              sx={{ fontSize: "16px", color: "gray" }}
                            >
                              {userData?.users?.find(
                                (a) => a._id === u.added_by
                              )?.name || "-"}
                            </Typography>
                            <Typography
                              sx={{ fontSize: "12px", color: "gray" }}
                            >
                              {new Date(
                                u.date || u.createdAt
                              ).toLocaleDateString()}
                            </Typography>
                          </Box>
                        </Box>
                      ))
                  ) : (
                    <Typography sx={{ fontSize: "14px", mt: 1, color: "gray" }}>
                      No updates added.
                    </Typography>
                  )}
                </Box>
              ))}
            </Box>
          )}
        </Sheet>
      </Modal>
      {/* Design Status Update */}
      <Modal
        open={openConfirmDesignComplete}
        onClose={handleCloseConfirmDesignComplete}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Sheet
          variant="outlined"
          sx={{
            maxWidth: 300,
            width: "100%",
            bgcolor: "#FEDDDD",
            p: 3,
            borderRadius: "md",
            boxShadow: "lg",
          }}
        >
          {/* <ModalClose onClick={handleCloseConfirmDesignComplete} /> */}

          <Typography
            level="h5"
            sx={{ mb: 2, textAlign: "center", fontWeight: "bolder" }}
          >
            Change Design status?
          </Typography>

          <FormControl sx={{ mb: 3 }} fullWidth>
            {/* <InputLabel>Status</InputLabel> */}
            <Select
              variant="standard"
              value={designStatus}
              onChange={(e) => setDesignStatus(e.target.value)}
              required
              placeholder="Select status"
            >
              <MenuItem value="cancelled">Cancelled</MenuItem>
              <MenuItem value="completed">Completed</MenuItem>
            </Select>
          </FormControl>

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button
              variant="outlined"
              onClick={handleCloseConfirmDesignComplete}
              sx={{
                color: "#fff",
                backgroundColor: "#800001",
                "&:hover": {
                  backgroundColor: "#800001",
                  color: "#fff",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              disabled={!designStatus}
              onClick={handleCompleteDesignConfirm}
              sx={{
                color: "#fff",
                backgroundColor: "#800001",
                "&:hover": {
                  backgroundColor: "#800001",
                  color: "#fff",
                },
              }}
            >
              Submit
            </Button>
          </Box>
        </Sheet>
      </Modal>
      {/* asset Status Update Modal */}
      <Modal
        open={openConfirmAssetStatus}
        onClose={handleCloseAssetStatus}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Sheet
          variant="outlined"
          sx={{
            maxWidth: 300,
            width: "100%",
            bgcolor: "#FEDDDD",
            p: 3,
            borderRadius: "md",
            boxShadow: "lg",
          }}
        >
          {/* <ModalClose onClick={handleCloseConfirmSchemeComplete} /> */}

          <Typography
            level="h5"
            sx={{ mb: 2, textAlign: "center", fontWeight: "bolder" }}
          >
            Change Asset status?
          </Typography>

          <FormControl sx={{ mb: 3 }} fullWidth>
            {/* <InputLabel>Status</InputLabel> */}
            <Select
              variant="standard"
              value={assetStatus}
              onChange={(e) => setAssetStatus(e.target.value)}
              required
              placeholder="Select status"
            >
              <MenuItem value="cancelled">Cancelled</MenuItem>
              <MenuItem value="completed">Completed</MenuItem>
            </Select>
          </FormControl>

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button
              variant="outlined"
              onClick={handleCloseAssetStatus}
              sx={{
                color: "#fff",
                backgroundColor: "#800001",
                "&:hover": {
                  backgroundColor: "#800001",
                  color: "#fff",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              disabled={!assetStatus}
              onClick={handleConfirmAssetStatus}
              sx={{
                color: "#fff",
                backgroundColor: "#800001",
                "&:hover": {
                  backgroundColor: "#800001",
                  color: "#fff",
                },
              }}
            >
              Submit
            </Button>
          </Box>
        </Sheet>
      </Modal>

      <AddDesign
        openDesign={openDesign}
        setOpenDesign={setOpenDesign}
        designId={designId}
        setDesignId={setDesignId}
        assetId={assetId}
      />
    </React.Fragment>
  );
}
